import dayjs from "dayjs";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import et from "./locales/et.json";
import lv from "./locales/lv.json";

// UI strings ship with the bundle. Edit src/locales/*.json; locales.test.ts keeps them in sync.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      et: { translation: et },
      lv: { translation: lv },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "et", "lv"],
    debug: process.env.NODE_ENV === "development",

    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false, // React already escapes values.
    },
  })
  .then(() => {
    // Sync dayjs locale with i18next's current language.
    dayjs.locale(i18n.language);
  });

export default i18n;
